import { injectTranslate } from '@core/i18n-legacy';
import { textCellFactory } from '@core/user-interface-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const newCandidatesCountColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.NewCandidatesCount,
  label: injectTranslate()('app.offers.table.new_candidates_count'),
  visible: false,
  geometry: {
    width: 130,
    minWidth: 130,
    maxWidth: 130,
  },
  options: {
    draggable: false,
    resizable: false,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('newCandidatesCount', value => (value ? `+ ${value}` : null)),
}));
